/**
 *  分模块翻译，方便维护
 *  lang/zh-cn/module/nav.js
 */

export default {
  "nav": {
    "title": "芯之元，一站到位！",
    "keywords": "半导体, 集成电路, 芯片, IC, 元器件, 供应链, BOM, 分销, 代理, 交易, 电商, 平台",
    "description": "icHub是一个芯片和元器件交易平台－为芯片和元器件供应链上下游赋能，提供交流和交易服务",

    "search": "搜",
    "shop_name": "芯之元供应链管理（深圳）有限公司",
    "short_shop_name": "芯之元",
    "user": "用户",
    "hot": "热",
    "visit": "出访",
    "service": "服务",
    "dealership": "经销商",
    "search_history": "搜索历史",

    "cms": "内容",
    "info": "商户",
    "biz": "业务",
    "cart": "买卖车",
    "order": "订单",
    "setting": "设置",
    "erp": "后台",
    "store": "前台",

    "home": "媒体",
    "sku": "商品",
    "shop": "商圈",
    "member": "芯人类",
    "spu": "品项",
    "brand": "厂牌",
    "category": "类目",
    "post": "文稿",
    "image": "视图",
    "all": "所有",

    "like": "点赞",
    "favorite": "收藏",
    "message": "留言",

    "trending": "热文",
    "comment": "热评",
    "topic": "热搜",
    "last_week": "上周",
    "last_month": "上月",
    "recommend": "推荐",
    "self_recommend": "自荐",
    "invitation": "邀请",
    "notice": "公告",
    "statistics": "业绩",
    "label": "标签",
    "more":"更多"
  }
};